<div class="ui-g-12">
  <form id="new-address-form" *ngIf="newAddressForm" [formGroup]="newAddressForm" [ngClass]="{'invalid-submit': invalidSubmit}">
    <div class="ui-g-12 delivery-info-section">
      <span class="label delivery-info-title">{{ 'common.customer' | translate }}</span>
      <!-- Nome -->
      <div class="ui-g-12 ui-md-6">
        <span class="label required">{{ 'reservations.name' | translate }}</span>
        <input type="text" pInputText class="fieldInput" formControlName="name"/>
        <span class="input-error-notification" *ngIf="invalidSubmit && newAddressForm.controls['name'].errors?.required">{{ 'common.required_error' | translate }}</span>
      </div>
      <!-- Cognome -->
      <div class="ui-g-12 ui-md-6">
        <span class="label required">{{ 'reservations.surname' | translate }}</span>
        <input type="text" pInputText class="fieldInput" formControlName="surname"/>
        <span class="input-error-notification" *ngIf="invalidSubmit && newAddressForm.controls['surname'].errors?.required">{{ 'common.required_error' | translate }}</span>
      </div>
    </div>
    <div class="ui-g-12 delivery-info-section">
      <span class="label delivery-info-title">{{ 'common.address' | translate }}</span>
      <div class="ui-g-12">
        <!-- Toponimo -->
        <div class="ui-g-12 ui-md-2">
          <span class="label required">{{ 'reservations.toponym' | translate }}</span>
          <p-dropdown [options]="toponyms" formControlName="toponym" [style]="{'width':'100%'}"></p-dropdown>
          <span class="input-error-notification" *ngIf="invalidSubmit && newAddressForm.controls['toponym'].errors?.required">{{ 'common.required_error' | translate }}</span>
        </div>
        <!-- Indirizzo -->
        <div class="ui-g-12 ui-md-8">
          <span class="label required">{{ 'reservations.address' | translate }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="address"/>
          <span class="input-error-notification" *ngIf="invalidSubmit && newAddressForm.controls['address'].errors?.required">{{ 'common.required_error' | translate }}</span>
        </div>
        <!-- Numero Civico -->
        <div class="ui-g-12 ui-md-2">
          <span class="label required">{{ 'reservations.number' | translate }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="number"/>
          <span class="input-error-notification" *ngIf="invalidSubmit && newAddressForm.controls['number'].errors?.required">{{ 'common.required_error' | translate }}</span>
        </div>
      </div>
      <div class="ui-g-12">
        <!-- Scala - Piano - Interno (Address2) -->
        <div class="ui-g-12">
          <span class="label">{{ 'reservations.staircase' | translate }} - {{ 'reservations.floor' | translate }} - {{ 'reservations.apartment' | translate }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="address2"/>
        </div>
      </div>
      <div class="ui-g-12">
        <!-- Cap -->
        <div class="ui-g-12 ui-md-3">
          <span class="label required">{{ 'reservations.zip' | translate }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="zip"/>
          <span class="input-error-notification" *ngIf="invalidSubmit && newAddressForm.controls['zip'].errors?.required">{{ 'common.required_error' | translate }}</span>
        </div>
        <!-- Città -->
        <div class="ui-g-12 ui-md-5">
          <span class="label required">{{ 'reservations.city' | translate }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="city"/>
          <span class="input-error-notification" *ngIf="invalidSubmit && newAddressForm.controls['city'].errors?.required">{{ 'common.required_error' | translate }}</span>
        </div>
        <!-- Provincia -->
        <div class="ui-g-12 ui-md-4">
          <span class="label required">{{ 'reservations.province' | translate }}</span>
          <p-dropdown [options]="provinces" formControlName="province" [style]="{'width':'100%'}"></p-dropdown>
          <span class="input-error-notification" *ngIf="invalidSubmit && newAddressForm.controls['province'].errors?.required">{{ 'common.required_error' | translate }}</span>
        </div>
      </div>
    </div>
  </form>
</div>
<!-- Button Inserisci Indirizzo -->
<div class="ui-g-12" style="text-align: center;">
  <button
    pButton
    class="k-generic-btn"
    (click)="saveAddress()"
    type="button"
    label="{{'reservations.enterAddress' | translate}}">
  </button>
</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-gift-reservation/confirm-gift-reservation-form/new-address-form/new-address-form.component.html